import React, { useEffect, useState } from 'react';
import 'twin.macro';
import { LoadingDots } from '../loading';
import { changeEmail } from 'services/user';
import { Notification } from '../notifications';
import { Paragraph, Title } from '../text';
import { useUnmounted } from '../common/hooks';
export const SUBMIT_CHANGE_SUCCESS_MESSAGE = 'Je nieuwe email is succesvol geverifieerd.';
export const SUBMIT_CHANGE_ERROR_MESSAGE = 'Er gaat iets fout... probeer het nog eens';

export const ChangeEmailForm = ({ token }) => {
  const unmounted = useUnmounted();
  const [pending, setPending] = useState(false);
  const [confirmSuccess, setConfirmSuccess] = useState(false);
  const [notification, setNotification] = useState({});

  const send = (e) => {
    setPending(true);
    setNotification({});

    changeEmail({
      hashcode: token,
    })
      .then(() => {
        if (!unmounted.current) {
          setPending(false);
          setNotification({ state: 'success', message: SUBMIT_CHANGE_SUCCESS_MESSAGE });
          setConfirmSuccess(true);
        }
      })
      .catch((e) => {
        if (!unmounted.current) {
          const error =
            e.response && e.response.data.errors
              ? e.response.data.errors[0].Message
              : SUBMIT_CHANGE_ERROR_MESSAGE;
          setPending(false);
          setNotification({ state: 'error', message: error });
        }
      });
  };

  useEffect(() => {
    send();
  }, []);

  return (
    <>
      {notification.state && (
        <Notification
          message={notification.message}
          style={notification.state}
          onClick={() => setNotification({})}
          tw='mb-4'
        />
      )}
      {pending && <LoadingDots />}
      {confirmSuccess && (
        <>
          <Title text='Je emailadres is aangepast.' />
          <Paragraph>Vanaf nu log je in met je nieuwe emailadres.</Paragraph>
        </>
      )}
    </>
  );
};
